
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import ReactTost from "../../ReactTost";
import { useTranslation } from "react-i18next";

import Loader from "../../Loader";
import { toBeDisabled } from "@testing-library/jest-dom/matchers";

const DeleteBot = (props) => {
  const {t} = useTranslation(); 
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const[loading,setLoading]=useState(false)
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  function DeleteBot(id) {
    if (id) {
      setLoading(true)
      axios
        .delete(`${API_URL}/${API_VERSION}/bot/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setLoading(false)
          setType("Success");
          setMessage(t("You bot is deleted."));
          setShowAlert(true);
          props.onDeleteSuccess();
          props.onHide();
        })
        .catch((error) => {
          setLoading(false)
          setType("Danger");
          setMessage(t("Something went to wrong."));
          setShowAlert(true);
        });
    }
  }

  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />

      {loading ? <Loader/> :
      <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("Delete Chatbot")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t("Are you sure you want to delete your Chatbot? This action cannot be undone.")}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="button" onClick={props.onHide}>
            {t("Cancel")}
          </button>
          <button className="button color_orange" onClick={() => {DeleteBot(props.deleteBotId);}}>{t("Delete")}</button>
        </Modal.Footer>
      </Modal>}
    </>
  );
};

export default DeleteBot;
